module.exports = __webpack_public_path__ + "08e23dea29ec13584d9c10809991f41d.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/menu/dark_mode.svg
// module id = 164
// module chunks = 0